import { useRef } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { Star } from "react-feather";

export const CampaignTag = ({ campaignName, width, style }: any) => {
  const imgRef = useRef(null);
  return (
    <div style={{ position: "relative" }}>
      <div className="campaign-icon" style={style}>
        <div className="campaign-image">
          <img
            width={width}
            ref={imgRef}
            src={
              require(`@src/assets/images/vyrill/videos/campaignIcon.png`)
                .default
            }
          />
          <UncontrolledTooltip
            placement="top"
            target={imgRef}
            style={{ background: "#E4F9F7", color: "black" }}
          >
            {campaignName}
          </UncontrolledTooltip>
        </div>
      </div>
    </div>
  );
};

export const RatingStars = ({ width, rating }: any) => {
  return (
    <div style={{ position: "relative" }}>
      <div className="rating-background">
        <div className="d-flex align-items-center rating-stars">
          {Array.from({ length: 5 }, (_, index) => (
            <div key={index}>
              {index < rating ? (
                <img
                  width={width}
                  style={{marginBottom:"1px"}}
                  src={
                    require(`@src/assets/images/vyrill/icons/star_fill.png`)
                      .default
                  }
                />
              ) : (
                <Star size={width} color="#FAFFBE" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
